<template>
  <div class="wrapper">
    <div class="actBar">
      <div>
        <el-button type="primary" size="small" @click="applyAct('create')"
          >新建报名</el-button
        >
        <el-button type="danger" plain size="small" @click="applyAct('delete')"
          >删除报名</el-button
        >
      </div>

      <el-pagination
        layout="prev, pager, next"
        :current-page.sync="searchCondition.jumpPage"
        :page-size.sync="searchCondition.pageSize"
        :total="searchCondition.total"
        @current-change="searchApplyList"
      >
      </el-pagination>
    </div>
    <div class="tableContainer">
      <div class="titleBar">
        <el-checkbox
          :value="ifSelectAllApply"
          @change="selectAllApply"
          style="margin-right: 15px"
          >全选
        </el-checkbox>
        共{{ searchCondition.total }}项记录
      </div>
      <div class="applyBar" v-for="item in applyList" :key="'apply' + item.id">
        <el-checkbox style="padding: 20px" v-model="item.choose"> </el-checkbox>
        <div class="applyContent">
          <el-image
            v-if="item.image"
            fit="contain"
            class="applyImage"
            :src="item.image"
          ></el-image>
          <div class="applyImage" v-if="!item.image">默认背景</div>
          <div class="applyData">
            <div class="applyName" @click="showShareUrl(item)">
              {{ item.name }}
            </div>
            <div class="greyFont">
              <i class="el-icon-s-custom"></i> {{ item.groupName }} ￥{{
                item.cost
              }}
              <i class="el-icon-user"></i> {{ item.maxTotal }}人
            </div>
            <div class="greyFont">
              报名时间 {{ item.startTime && item.startTime.split(" ")[0] }} -
              {{ item.endTime && item.endTime.split(" ")[0] }}
            </div>
          </div>
          <div class="keyvalBox centerFont">
            <div class="blueFont">{{ item.costTotal }}元</div>
            <div class="greyFont">收益</div>
          </div>
          <div class="keyvalBox centerFont">
            <div class="blueFont">{{ item.count }}人</div>
            <div class="greyFont">已报名人数</div>
          </div>
          <div class="actBar">
            <i
              class="el-icon-s-custom blueFont"
              title="查看报名学生"
              @click="toDetail(item)"
            ></i>
            <i
              class="el-icon-edit-outline blueFont"
              title="报名编辑"
              @click="toEdit(item)"
            ></i>
            <el-popover placement="bottom" width="200" v-model="item.ifCopy">
              <el-button
                title="报名复制"
                type="text"
                slot="reference"
                @click="Object.assign(copyApplyData, item)"
                ><i class="el-icon-document-copy blueFont"></i
              ></el-button>
              <h3>请输入新报名链接名</h3>
              <el-input
                size="mini"
                style="margin: 8px 0"
                v-model="copyApplyData.name"
              ></el-input>
              <div style="text-align: right">
                <el-button size="mini" type="text" @click="item.ifCopy = false"
                  >取消</el-button
                >
                <el-button type="primary" size="mini" @click="copyApply"
                  >确定</el-button
                >
              </div>
            </el-popover>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :title="shareItem.name"
      :visible.sync="shareItemIfShow"
      width="70%"
      :append-to-body="true"
    >
      <div class="shareBox">
        <div class="shareContent">
          <div class="title">方式一：分享报名链接</div>
          <el-input disabled v-model="shareExamUrl" class="urlInput"></el-input>
          <div class="actBar">
            <el-button type="primary" size="mini" @click="copyText"
              >复制</el-button
            >
            <el-button type="primary" size="mini" @click="jumpTo" plain
              >打开</el-button
            >
          </div>
        </div>
        <div class="shareContent">
          <div class="title">扫码报名</div>
          <div class="centerFont bigFont">{{ shareItem.exName }}</div>
          <vue-qr
            :text="shareExamUrl"
            id="qrcodeImg"
            ref="qrcodeImg"
            style="display: block; margin: auto"
          ></vue-qr>
          <div class="greyFont centerFont">把二维码分享给您的学生</div>

          <div class="actBar">
            <el-button type="primary" size="mini" @click="downloadQrcode"
              >下载二维码</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getApplyList,
  deleteApply,
  copyApply,
} from "@/api/examination/student.js";
import { Base64 } from "@/libs/js/base64.js";
import vueQr from "vue-qr";

export default {
  data() {
    return {
      searchCondition: {
        jumpPage: 1,
        pageSize: 10,
        total: 0,
      },
      copyApplyData: {
        id: 0,
        name: "",
      },
      totalCopyData: {
        id: 0,
        name: "",
        ifShow: false,
      },
      applyList: [],
      shareItemIfShow: false,
      shareItem: "",
      Base64: new Base64(),
    };
  },
  computed: {
    ifSelectAllApply() {
      return this.applyList.every((item) => item.choose);
    },
    // shareExamUrlV1() {
    //   let query = this.Base64.encode(`applyId-${this.shareItem.id}`);
    //   return `${document.location.protocol}//${document.location.host}/apply/#/?${query}`;
    //   //  return `http://cbtest.cbstudy.cn:8060/apply/#/?${query}`;
    // },


    shareExamUrl() {
      let query = this.Base64.encode(`applyId-${this.shareItem.id}`);
      //let host = "xktest.cbstudy.com/apply";

      let host = "xkptweb.yukonsys.com.cn/applyin";
      return  `http://${host}/#/?${query}`;
      //  return `http://cbtest.cbstudy.cn:8060/apply/#/?${query}`;
    },
  },
  components: { vueQr },
  created() {},
  mounted() {
    this.searchApplyList();
  },
  methods: {
    selectAllApply() {
      if (this.applyList.every((item) => item.choose)) {
        this.applyList.forEach((item) => {
          item.choose = false;
        });
      } else {
        this.applyList.forEach((item) => {
          item.choose = true;
        });
      }
    },
    searchApplyList() {
      getApplyList(this.searchCondition).then((data) => {
        console.log(data);
        data.pagedResult.records.forEach((item) => {
          item.choose = false;
          item.ifCopy = false;
        });
        this.applyList = data.pagedResult.records;
        this.searchCondition.total = data.pagedResult.total;
      });
    },
    copyApply() {
      copyApply({
        id: this.copyApplyData.id,
        name: this.copyApplyData.name,
      }).then((data) => {
        this.$message.success("复制成功");
        this.searchApplyList();
      });
    },
    showShareUrl(item) {
      if (!item.groupId) {
        this.$message.error(
          "该报名没有设置考生分组，无法正常报名，请修改后再分享报名链接"
        );
        return;
      }
      console.log(item);
      this.shareItem = item;
      this.shareItemIfShow = true;
    },
    applyAct(type) {
      switch (type) {
        case "create":
          this.$router.push({
            name: "applyEdit",
          });
          break;
        case "delete":
          let deleteList = this.applyList.filter((item) => item.choose);
          if (deleteList.length == 0) {
            return;
          }
          this.$confirm(`确认删除此${deleteList.length}条报名吗`, "提示", {
            confirmButtonText: "删除",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            deleteApply({ id: deleteList.map((item) => item.id) }).then(() => {
              this.$message.success("删除成功");
              this.searchApplyList();
            });
          });

          break;
        case "copy":
          if (this.applyList.filter((item) => item.choose).length > 1) {
            this.$message.error("只能选择一个报名复制");
            return;
          }
          if (this.applyList.filter((item) => item.choose).length < 1) {
            this.$message.error("请选择一个报名");
            return;
          }
          var copyApply = this.applyList.find((item) => item.choose);
          copyApply({ id: copyApply.id, name: this.totalCopyData.name }).then(
            (data) => {
              console.log(data);
              this.$message.success("复制成功");
              this.searchApplyList();
            }
          );

          break;

        default:
          break;
      }
    },
    toDetail(item) {
      this.$router.push({
        name: "studentOnApply",
        query: {
          id: item.id,
        },
      });
    },
    toEdit(item) {
      this.$router.push({
        name: "applyEdit",
        query: {
          applyId: item.id,
        },
      });
    },
    downloadQrcode: function (imgsrc, name) {
      var image = new Image();

      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        console.log(image);
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL(); //得到图片的base64编码数据

        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || new Date().getTime(); // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      // image.src = document.getElementById("qrcodeImg").src;
      image.src = this.$refs.qrcodeImg.$el.src;
    },
    copyText() {
      console.log(this.shareExamUrl);
      var input = document.createElement("input");
      input.value = this.shareExamUrl;
      document.body.appendChild(input);
      input.select();
      document.execCommand("Copy");
      document.body.removeChild(input);
      this.$message.success("复制成功");
    },
    jumpTo() {
      window.open(this.shareExamUrl, "_blank");
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  padding: 10px;
  .actBar {
    padding: 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .el-pagination {
      padding: 0;
    }
  }
  .tableContainer {
    background: #fff;
    padding: 10px;
    .titleBar {
      padding: 10px 0;
    }
    .applyBar {
      background: #fff;
      display: flex;
      justify-content: space-between;
      padding: 5px 0;
      border: 1px solid #ccc;
      margin: 5px 0;
      .applyContent {
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .applyImage {
          width: 120px;
          height: 90px;
          background: #fff;
          line-height: 100px;
          text-align: center;
        }
        .applyData {
          flex: 1;
          .applyName {
            cursor: pointer;
          }
        }
        .keyvalBox {
          width: 120px;
        }
        .actBar {
          width: 120px;
          justify-content: center;
          i {
            font-size: 18px;
            cursor: pointer;
          }
          i + i {
            margin: 0 5px;
          }
        }
      }
      .applyContent > div {
        margin: 0 8px;
      }
    }
  }
}
.shareBox {
  display: flex;
  justify-content: space-around;
  background: #f6f8ff;
  padding: 20px 10px;
  .shareContent {
    background: #fff;
    padding: 10px 10px 60px 10px;
    margin: 0 10px;
    flex: 1;
    position: relative;
    .title {
      font-size: 1.05rem;
    }
    .urlInput {
      display: block;
      width: 100%;
    }
    .actBar {
      position: absolute;
      text-align: center;
      bottom: 20px;
      width: 100%;
      left: 0;
    }
    .qrcode {
      width: 170px;
      height: 170px;
      display: block;
      margin: 15px auto;
    }
    .downloadBtn {
    }
  }
}
/deep/ .el-checkbox__inner {
  height: 20px;
  width: 20px;
}
/deep/ .el-checkbox__inner::after {
  width: 4px;
  height: 12px;
  left: 6px;
  top: 0;
  border-width: 2px;
}
</style>
